import { dimensionOf } from "../dimensionOf";
import { planCellKeyOf } from "../planCellKeyOf";
import { FOLDER_STRUCTURE_ORDER } from "./constants";
import type { ListFolderStructures } from "./types";

export const listFolderStructures: ListFolderStructures = ({ suggestion }) => {
  const cellKeys = new Set<string>();
  let hasSharedCell = false;
  for (const plan of suggestion.plans) {
    const cellKey = planCellKeyOf({ plan });
    if (cellKey === null) continue;
    if (cellKeys.has(cellKey)) {
      hasSharedCell = true;
      break;
    }
    cellKeys.add(cellKey);
  }

  // One folder per building and level only groups something when a cell holds several plans.
  return FOLDER_STRUCTURE_ORDER.filter((structure) =>
    structure === "buildingAndLevel"
      ? hasSharedCell
      : dimensionOf({ suggestion, key: structure }) !== null,
  );
};
